peque.unloggedUser = (function () {
  "use strict";

  var loginInit = function () {
    microsoftLogin();
    const $container = document.getElementById("login-container");
    const $button = $container.querySelector('button[type="submit"]');

    $container.addEventListener("submit", (e) => {
      e.preventDefault();
      enableSubmitButton($button, false);

      const email = $container.querySelector('[name="email"]').value,
        code = $container.querySelector('[name="code"]').value,
        password = $container.querySelector('[name="password"]').value;

      if (email === "" || password === "") {
        enableSubmitButton($button, true);
        return false;
      }
      $container.querySelector(".error").classList.add("d-none");

      // Do not point this to peque.navigation.post|peque.api as they attempt to fix
      // errors like failed authentication (causing a loop to login)
      peque
        .api(
          "users/login",
          { email: email, password: password, code: code },
          "post"
        )
        .then((data) => {
          if ($_GET("redirect") === null) {
            peque.navigation.redirect("appHome");
          } else {
            peque.navigation.redirect(decodeURIComponent($_GET("redirect")));
          }
        })
        .catch((response) => {
          enableSubmitButton($button, true);

          if (typeof response.field !== "undefined" && response.field) {
            const codeContainer = document.getElementById("2fa-container");
            const codeInput = codeContainer.querySelector("input");

            // not the first time showing it up
            if (!codeContainer.classList.contains("d-none")) {
              codeInput.classList.add("is-invalid");
            }

            codeContainer.classList.remove("d-none");
            codeInput.focus();
            return;
          }
          $container.querySelector(".error").classList.remove("d-none");
        });
    });
  };

  const enableSubmitButton = ($button, enable) => {
    if (enable) {
      $button.removeAttribute("disabled");
    } else {
      $button.disabled = "disabled";
    }
  };

  var signupInit = function () {
    microsoftLogin();
    const $container = document.getElementById("signup-wrapper");
    const $button = $container.querySelector('button[type="submit"]');
    $container.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      enableSubmitButton($button, false);

      let data = {
        email: $container.querySelector('[name="email"]').value,
        password: $container.querySelector('[name="password"]').value,
        country: $container.querySelector('[name="country"]').value,
        ref: $_GET("ref"),
        code: $_GET("code"),
        id: $_GET("id"),
        type: $_GET("type"),
        terms: $container.querySelector('[name="terms"]').checked,
      };

      if (
        data.password == "" ||
        data.email == "" ||
        !data.terms ||
        data.country == 0
      ) {
        enableSubmitButton($button, true);
        return false;
      }

      if ($_GET("ceo")) {
        data.name = $_GET("ceo");
        data.role = "founder";
      }

      const $error = $container.querySelector(".error");

      $error.classList.add("d-none");

      // Do not point this to peque.navigation.post|peque.api as they attempt to fix
      // errors like failed authentication (causing a loop to login)
      peque
        .api("users", data, "post")
        .then(function (response) {
          if (response == "" || response.error > 0) {
            enableSubmitButton($button, true);
            $error.classList.remove("d-none");
            return false;
          }

          if ($_GET("redirect") === null) {
            if (typeof data.role !== "undefined") {
              peque.navigation.redirect(
                "/app/company/create?name=" + $_GET("company")
              );
            } else {
              peque.navigation.redirect("/app/user/onboarding");
            }
          } else {
            peque.navigation.redirect(decodeURIComponent($_GET("redirect")));
          }
        })
        .catch((response) => {
          enableSubmitButton($button, true);
          if (response.error === 10) {
            $error.innerHTML = "Email already in use";
          } else {
            $error.innerHTML = "Error";
          }
          $error.classList.remove("d-none");
        });
    });
  };

  const microsoftLogin = () => {
    document.getElementById("microsoft-login").addEventListener("click", () => {
      if (!window.msalInstance) {
        const msalConfig = {
          auth: {
            clientId: "97d50891-7439-4814-bc23-4fead6dfe253",
          },
        };

        window.msalInstance = new msal.PublicClientApplication(msalConfig);
      }

      window.msalInstance
        .loginPopup({
          redirectUri: peque.routeFor("microsoftLogin"),
          scopes: ["User.Read", "email"],
        })
        .then((response) => {
          window.location =
            peque.routeFor("microsoftLogin") +
            "?" +
            new URLSearchParams({ t: response.idToken }).toString();
        })
        .catch(console.error);
    });
  };

  return {
    loginInit: loginInit,
    signupInit: signupInit,
  };
})();
